import ContentPage from './ContentPages';

const YourSecurity = () => <ContentPage slug="your-security" />;

export default YourSecurity;
